import React, { useState, useContext, useEffect, useRef } from 'react';
import { Helmet } from "react-helmet";
import { Link, Redirect, useHistory } from 'react-router-dom';
import useNetwork from '../useNetwork';
import useInfiniteScroll from "../useInfiniteScroll";
import { urlEncodeText } from '../helpers';
import { AuctionTile } from './auction/AuctionTile';
import { AppDataContext, VLink } from "./AppDataContext"



export function Seller(props) {
	const { loading, networkError, netRequest, netRenderError } = useNetwork(true);
	const context = useContext(AppDataContext);
	const [isFetching, setIsFetching, isDone, setIsDone] = useInfiniteScroll(getAuctions);

	const [seller, setSeller] = useState(null);
	const [auctions, setAuctions] = useState(null);
	const [directors, setDirectors] = useState([]);
	const [isFollowing, setIsFollowing] = useState(null);

	const startIx = useRef(0);
	const auctionSessionCount = useRef(0);
	// use a page size that show well with 3 as well as 2
	const pageSize = 12;

	const onFollow = async () => {
		// initially toggle to the new state
		const currentlyIsFollowing = isFollowing;
		setIsFollowing(!currentlyIsFollowing);

		const url = 'api/site/setfollow';
		const postData = {
			secureId: seller.secureId,
			isFavorite: !isFollowing,
		};

		const response = await netRequest(url, postData);

		if (response.data != null) {
			// failed?  put it back
			setIsFollowing(currentlyIsFollowing);
		}

	};

	function getSeller(frombeginning = false) {
		const fetchSeller = async () => {
			const url = 'api/site/getsellercompany/' + props.match.params.sellerId;

			const response = await netRequest(url);

			if (response.data != null) {
				setSeller(response.data);
				setIsFollowing(response.data.isFollowing);
			}
		}
		fetchSeller();
	}

	// this useEffect has [] as the parms, so only gets call on didMount
	useEffect(() => {
		getSeller();
	}, []);

	useEffect(() => {
		getSeller();
	}, [context.isLoggedIn]);


	function getAuctions(startAtBeginning) {

		const fetchAuctions = async (startingAt) => {

			if (startingAt == 0 || startIx.current < auctionSessionCount.current) {

				const url = 'api/site/getauctions/' + startingAt + '/' + pageSize + "/" + props.tab + '/' + props.match.params.sellerId;

				const response = await netRequest(url);

				if (response.data != null) {

					if (startingAt == 0)
						setAuctions(response.data.auctionSessions);
					else
						setAuctions([...auctions, ...response.data.auctionSessions]);
					// set our next starting point
					startIx.current = startingAt + pageSize;

					auctionSessionCount.current = response.data.auctionSessionCount;
					console.log("Total Count: " + auctionSessionCount.current);
					const isEndReached = startIx.current >= auctionSessionCount.current;
					if (isEndReached === true)
						console.log("End of Auction reached");
					setIsDone(isEndReached);

				}
			}
			setIsFetching(false);
		};

		if (startAtBeginning) {
			startIx.current = 0;
			setIsDone(false);
		}

		fetchAuctions(startIx.current);
	}

	useEffect(() => {

		const fetchDirectors = async () => {
			const url = 'api/site/getdirectors/' + props.match.params.sellerId;

			const response = await netRequest(url);

			if (response.data != null) {
				setDirectors(response.data);
			}
		};
		if (props.tab) {
			console.log("Tab Changed to: " + props.tab);
			setDirectors(null);
			setAuctions(null);
			if (props.tab != "directors") {
				getAuctions(true);
			} else {
				fetchDirectors();
			}
		}
	}, [props.tab]);

	if (seller == null) {
		return (
			<></>
		);
	}

    return (
		<main>
			<Helmet>
				<title>About the Seller - {seller.companyName}</title>
			</Helmet>
			<section class="p-3 p-md-5">
				<div class="container">
					<div class="row">
						<div class="col-12 col-md-6 mb-5 about--seller">
							<div class="w-100">
								<h1 class="d-inline display-6 me-3">About the Seller</h1>
								{context.isLoggedIn &&
									<button className={"btn btn-primary mb-3 mb-md-0 " + (isFollowing ? "active" : "")} onClick={onFollow} title={"Follow" + (isFollowing ? "ing" : "")}><i class="bi bi-bell me-2"></i>Follow{(isFollowing ? "ing" : "")}</button>
								}
							</div>
							<div class="divider mb-3"></div>
							<img src={"api/site/SellerLogo/" + seller.secureId} class="mx-auto d-block mb-3 logo--md" title={seller.companyName} alt={seller.companyName} />
							<p>{seller.description}</p>
						</div>
						<div class="col-12 col-md-6 mb-5">
							<h1 class="display-6">Contact Details</h1>
							<div class="divider mb-3"></div>
							<div class="d-flex align-items-center pickup__content py-2">
								<div class="d-inline me-3">
									<i class="bi bi-pin-map"></i>
								</div>
								<div class="d-inline">
									<h4 class="mb-0 pb-0" >{seller.companyName}</h4>
									<h5 class="mb-0 pb-0">{seller.address1}, {seller.city}, {seller.state} {seller.zip}</h5>
								</div>
							</div>
							<div class="d-flex align-items-center pickup__content py-2">
								<div class="d-inline me-3">
									<i class="bi bi-envelope"></i>
								</div>
								<div class="d-inline">
									<h4 class="mb-0 pb-0" >Email</h4>
									<h5 class="mb-0 pb-0"><a href={"mailto:" + seller.email}>{seller.email}</a></h5>
								</div>
							</div>
							<div class="d-flex align-items-center pickup__content py-2">
								<div class="d-inline me-3">
									<i class="bi bi-phone"></i>
								</div>
								<div class="d-inline">
									<h4 class="mb-0 pb-0" >Phone</h4>
									<h5 class="mb-0 pb-0">{seller.phone}</h5>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section class="background-color">
				<div class="container">
					<div class="row">
						<div class="col-12">
							{ /* Nav tabs */ }
							<ul class="nav nav-tabs nav-justified nav-tabs-adjusted">
								<li class="nav-item">
									<VLink to={"/seller/" + props.match.params.sellerId} class={"nav-link " + (props.tab == "current" ? "active" : "")}  >Current Auctions</VLink>
								</li>
								<li class="nav-item">
									<VLink to={"/seller/" + props.match.params.sellerId + "/past"} class={"nav-link " + (props.tab == "past" ? "active" : "")}  >Past Auctions</VLink>
								</li>
								<li class="nav-item">
									<VLink to={"/seller/" + props.match.params.sellerId + "/directors"} class={"nav-link " + (props.tab == "directors" ? "active" : "")}  >Auction Managers</VLink>
								</li>
							</ul>

							{ /* Tab panes */ }
							<div class="tab-content">
								{props.tab != "directors" ?
									<>
									{auctions ?
										<div class="tab-pane container h-100 py-3 px-0 active">
											<div class="row">
												{
													auctions.length > 0 ?
														auctions.map((a) => <AuctionTile key={a.secureId} auction={a} showSeller={false} />)
														:
														<div class="col">
															No {props.tab == "current" ? "Current" : "Past"} Auctions
														</div>
												}
											</div>
											{isFetching && !isDone && <div>Fetching More...</div>}
											{(auctionSessionCount.current > 0 && isDone) && <div class="col-12"><p class="text-center end-of-auction">End of {props.tab == "current" ? "Current" : "Past"} Auctions</p></div>}
										</div>
										:
										<div class="row">
											Fetching Auctions...
										</div>
									}
									</>
								:
								directors ?
									<>

										{directors.length > 0 &&
										<div class="tab-pane container h-100 py-3 px-0 active">
											<div class="row">
												{directors.map((d) =>
													<div key={d.secureId} class="col-6 col-md-3 mb-4">
														<div class="auction--item">
															<div class="auction--item__content border-radius-huge">
																<div class="auction--item__content--details p-3">
																	<img class="d-block mx-auto mt-3" src={"/api/site/auctionmanagerphoto/" + d.secureId + "/100"} alt="Image" title="Image" />
																	<h3 class="text-center mb-0 pb-0">
																		<VLink to={"/director/" + d.secureId} className="mb-3 text-center">{d.firstName} {d.lastName}</VLink>
																	</h3>
																	<p class="mb-1 text-center">{d.position}</p>
																	<div class="d-flex justify-content-center pickup__content mx-auto pb-2">
																		<div class="d-inline me-2">
																			<i class="bi bi-envelope"></i>
																		</div>
																		<div class="d-inline">
																			<a href={"mailto:" + d.email} title={d.email}>{d.email}</a>
																		</div>
																	</div>
																	<div class="d-flex justify-content-center pickup__content mx-auto pb-2">
																		<div class="d-inline me-2">
																			<i class="bi bi-phone"></i>
																		</div>
																		<div class="d-inline">
																			{d.phone}
																		</div>
																	</div>
																	<VLink to={"/director/" + d.secureId} className="btn btn-secondary mb-3 mx-auto d-block">View more</VLink>
																</div>
															</div>
														</div>
													</div>
												)}
											</div>
										</div>
										}
									</>
									:
									<div class="row">
										Fetching Managers...
									</div>
								}
							</div>

						</div>
					</div>
				</div>
			</section>
		</main>


    );

}